export default "__VITE_ASSET__CE6ztPA5__"